var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankKakao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 23,
    rx: 3,
    fill: "#FFE300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.34 22.9986H6.65973C5.46732 22.9989 4.50033 22.0326 4.5 20.8402V2.15907C4.49967 0.966984 5.46582 0.000331357 6.65791 8.51491e-08H25.3407C26.5331 -0.000331187 27.5001 0.96599 27.5004 2.1584V20.8393C27.5001 22.0319 26.5332 22.9984 25.3407 22.9984",
    fill: "#FFE300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8516 11.5015H19.8511C21.5974 10.3525 22.0817 8.00572 20.9329 6.25942C20.5883 5.73565 20.119 5.30568 19.5672 5.00813C19.0154 4.71058 18.3983 4.55477 17.7714 4.55469H11.4262C11.3975 4.55456 11.369 4.56009 11.3425 4.57096C11.316 4.58183 11.2918 4.59784 11.2715 4.61805C11.2511 4.63827 11.2349 4.6623 11.2239 4.68878C11.2128 4.71525 11.2071 4.74365 11.207 4.77234V18.2299C11.2069 18.2587 11.2125 18.2872 11.2234 18.3139C11.2343 18.3405 11.2504 18.3647 11.2707 18.3851C11.291 18.4055 11.3151 18.4217 11.3417 18.4328C11.3682 18.4438 11.3967 18.4496 11.4255 18.4496H17.7715C19.8622 18.4496 21.557 16.7546 21.557 14.664C21.5568 14.0368 21.4009 13.4195 21.1033 12.8676C20.8056 12.3156 20.3755 11.8461 19.8516 11.5015ZM16.7366 14.6641H15.5454V8.33881H16.7366V14.6641Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankKakao);
export default __webpack_public_path__ + "static/media/BankKakao.0ba8e8c1d0290d4000807caf8f69575b.svg";
export { ForwardRef as ReactComponent };